export default (node) => {
  /**
   * Data + elements
   */
  const menuButton = node.querySelector('[data-mobile-submenu-button]');
  const closeMenuButton = node.querySelector('[data-close-submenu]');
  const subMenu = node.querySelector('[data-mobile-submenu]');

  const allAccordionButtons = node.querySelectorAll(
    '[data-toggle-accordion-menu]'
  );

  /**
   * Functions
   */

  const toggleSubMenu = () => {
    subMenu.classList.toggle('translate-x-full');
    subMenu.classList.toggle('translate-x-0');
  };

  const toggleAccordionMenu = (e) => {
    const button = e.target;
    const ariaExpanded = button.getAttribute('aria-expanded') === 'true';
    const subMenuId = button.attributes['aria-controls'].value;
    const subMenu = document.getElementById(subMenuId);

    subMenu.setAttribute('aria-hidden', ariaExpanded);
    button.setAttribute('aria-expanded', !ariaExpanded);
  };

  /**
   * Init
   */
  const init = () => {
    menuButton.addEventListener('click', toggleSubMenu);
    closeMenuButton.addEventListener('click', toggleSubMenu);
    allAccordionButtons.forEach((button) => {
      button.addEventListener('click', toggleAccordionMenu);
    });
  };

  init();
};
